import { RandomUtils } from '../utils/random-utils';

export enum CompetenceMotifEnum {
  INCREASE = 'INCREASE',
  REPLACEMENT = 'REPLACEMENT',
  PLACEMENT = 'PLACEMENT',
}

export const competenceMotifTranslation = (motif: CompetenceMotifEnum): string | null => {
  switch (motif) {
    case CompetenceMotifEnum.INCREASE.toString():
      return 'Surcroît';
    case CompetenceMotifEnum.REPLACEMENT.toString():
      return 'Remplacement';
    case CompetenceMotifEnum.PLACEMENT.toString():
      return 'Placement';
    default:
      return null;
  }
};

export const competenceMotifEnumObject = (motif: CompetenceMotifEnum) => ({
  _id: RandomUtils.generateId(),
  value: motif,
  label: competenceMotifTranslation(motif),
});

export const competenceMotifOptions = Object.values(CompetenceMotifEnum).map(competenceMotifEnumObject);

/**
 * PRED-3288 : _id des Motifs Metrik seedés par le back (SEEDED_COMPETENCE_MOTIF_IDS) qui reprennent
 * ces 3 valeurs historiques. Sert à pré-sélectionner le motif équivalent quand on édite un ticket legacy.
 */
export const LEGACY_COMPETENCE_MOTIF_IDS: Record<CompetenceMotifEnum, string> = {
  [CompetenceMotifEnum.INCREASE]: '68f6000000000000000000a1',
  [CompetenceMotifEnum.REPLACEMENT]: '68f6000000000000000000a2',
  [CompetenceMotifEnum.PLACEMENT]: '68f6000000000000000000a3',
};
